var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flux-image',{ref:"image",style:(_vm.style),attrs:{"image":_vm.from,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }